<template>
  <b-card title="واحدهای پولی">
    <b-alert variant="danger" :show="errors.length > 0">
      <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
    </b-alert>
    <b-alert variant="success" :show="success_errors.length > 0">
      <p v-for="x in success_errors" v-bind:key="x">{{ x }}</p>
    </b-alert>
    <b-modal
      id="modal-1"
      title="ویرایش قیمت"
      @ok="handleOk()"
      ok-title="ارسال"
      cancel-title="انصراف"
    >
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">درگاه</th>
            <th
              v-for="item_1 in Listupdate.money_type"
              :key="item_1.id"
              scope="col"
            >
              {{ item_1.title }}
            </th>
          </tr>
        </thead>
        <tr v-for="item in Listupdate.international_gateway" :key="item.id">
          <td class="align-middle">
            {{ item.title }}
          </td>
          <td v-for="element in item" :key="element.id">
            <b-form-input
              id="input_price"
              :placeholder="element.money_type_title"
              v-model="element.price"
              aria-describedby="input-1-live-feedback"
            ></b-form-input>
          </td>
        </tr>
      </table>
    </b-modal>

    <b-button variant="success" @click="editPrice">ویرایش</b-button>

    <b-card-text>
      <b-table
      responsive
        style="width: 100%"
        striped
        hover
        show-empty
        empty-text="آیتمی جهت نمایش وجود ندارد"
        :fields="fields"
        :items="List"
      >
        <!-- <template v-slot:cell(details)="row"> </template> -->
      </b-table>
    </b-card-text>
  </b-card>
</template>
<style>
.custom-select.is-valid,
.was-validated .custom-select:valid {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%231B283F' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
      no-repeat left 1rem center/8px 10px,
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath fill='%231BC5BD' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E")
      #fff no-repeat center left 2rem / calc(0.75em + 0.65rem)
      calc(0.75em + 0.65rem);
}

.custom-select.is-invalid,
.was-validated .custom-select:invalid {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%231B283F' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
      no-repeat left 1rem center/8px 10px,
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23F64E60'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23F64E60' stroke='none'/%3E%3C/svg%3E")
      #fff no-repeat center left 2rem / calc(0.75em + 0.65rem)
      calc(0.75em + 0.65rem);
}
[type="number"] {
  width: 100%;
}

.v-select.vs--single.vs--searchable button svg {
  display: none;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
import httpHelper from "@/helpers/httpHelper";
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import {
  email,
  minLength,
  required,
  maxLength,
} from "vuelidate/lib/validators";
import Table from "../../components/table.vue";
const numbers = (value, vm) => /^[\u06F0-\u06F9\s||z0-9]/.test(value);

export default {
  mixins: [validationMixin],
  name: "Exchange",
  data: function() {
    return {
      exchangeupdate_fields: [],
      price: "",
      errors: [],
      value: {
        price: "",
      },
      success_errors: [],
      List: [],
      Listupdate: [],
      priceList: null,
      length: 5,
      //priceList: Array.apply(null, { length: 6 }).map(Number.call, Number),
      fields: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "international_gateway.title",
          label: "نام درگاه",
        },
        {
          key: "money_type.title",
          label: "نام",
        },
        {
          key: "rate_name",
          label: "نماد",
        },
        {
          key: "rate_value",
          label: "نرخ ",
        },
        {
          key: "value",
          label: "مبلغ ",
        },
        {
          key: "created_at",
          label: "تاریخ",
          formatter: (value, key, item) => {
            return persianDate.getDate(value);
          },
        },
      ],
    };
  },
  validations: {
    value: {
      price: {
        required,
        numbers,
      },
    },
  },
  components: {
    "list-table": TableShowData,
    listTable: Table,
  },
  watch: {
    value: function(newval, oldval) {
      //this.form = newval;
    },
    validateInputswatcher: function(newval, oldval) {
      this.validateInputs();
    },
  },
  methods: {
    handleOk: function() {
      this.errors = [];
      this.success_errors = [];

      httpHelper
        .postData("exchange", {
          exchange_list: this.Listupdate.international_gateway,
        })
        .then((res) => {
          if (res.success && res.result !== null) {
            this.filterData();
            this.success_errors.push("عملیات با موفقیت انجام شد");
          } else {
            if (res.error) {
              for (var key in res.error) {
                this.errors.push(res.error[key][0]);
              }
            }
          }
        });
      this.filterData();
    },
    editPrice: function() {
      this.$bvModal.show("modal-1");
      httpHelper
        .getData("exchangelistupdate")
        .then((res) => {
          this.Listupdate = res.result;
          this.Listupdate.international_gateway = this.Listupdate.international_gateway.map(
            (element) => {
              var data = [];
              data["title"] = element.title;
              this.Listupdate.money_type.forEach((inmoney) => {
                data.push({
                  id: element.id + "_" + inmoney.id,
                  latin_code: inmoney.latin_code,
                  money_type: inmoney.id,
                  money_type_title: inmoney.title,
                  gateway: element.id,
                  gateway_title: element.title,
                  price: 0,
                });
              });
              return data;
            }
          );
        })
        .finally(() => {});
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    validateInputs() {
      this.$v.value.$touch();
    },
    setENChars(field) {
      this.$v.value[field].$model = this.value[field].toEnDigits();
    },
    filterData: function() {
      httpHelper
        .getData("exchange")
        .then((res) => {
          this.List = res.result;
        })
        .finally(() => {});
    },
  },
  created() {
    httpHelper.setAuth();
    this.filterData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "واحدهای پولی" }]);
  },
};
</script>
